module.exports = __webpack_public_path__ + "static/media/github.d34da490.png";